class Extranet.Models.GenericModel extends Backbone.Model
  idAttribute: 'uuid'

  initialize: () ->

